import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import { Box, Divider, Stack, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

// ---------------------- styled components -------------------------

const Brand = styled(Stack)(() => ({
  flexDirection: 'row',
  gap: '16px',
  alignItems: 'center',
  cursor: 'pointer',
}));

const BrandLogo = styled('img')(({ theme }) => ({
  width: '161px',
  height: '24.891px',
  objectFit: 'contain',

  [theme.breakpoints.down('md')]: {
    width: '156px',
    height: '24px',
  },
}));

const BrandDivider = styled(Divider)(({ theme, general = false }) => ({
  backgroundColor: general
    ? theme.palette.green.primary
    : theme.palette.grey[5],
  width: !general ? '1px' : '2px',
  height: !general && '70px',
}));

const BrandTitle = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[3],
  lineHeight: '1.2 !important',
  [theme.breakpoints.down('md')]: {
    width: '156px',
    height: '24px',
  },
}));

// ------------------------- component ------------------------------

const NavBrand = ({ redirect, title, isSamePathname }) => {
  const { pathname } = useLocation();

  const { isOnlinePath, isPracticePath, isOnCampusPath } = isSamePathname || {};

  const { selectedCourse } = useSelector((state) => state.studentLearning);

  const { programId } = selectedCourse || {};

  const isWatchpage = useMemo(() => {
    return isOnlinePath || isPracticePath || isOnCampusPath;
  }, [isOnCampusPath, isOnlinePath, isPracticePath]);

  const isExamPagePath =
    pathname.includes('/exam/') || pathname.includes('/exam-result/');

  const navLogoRedirect = useMemo(() => {
    let url = '/program';

    if (isOnlinePath || isPracticePath) {
      url = `/program/online/${programId}`;
    }

    if (isOnCampusPath) {
      url = `/program/on-campus/${programId}`;
    }

    return url;
  }, [isOnCampusPath, isOnlinePath, isPracticePath, programId]);

  const directToHome = () => {
    window.location.href = window.location.origin;
  };

  if (isExamPagePath) {
    return (
      <Link to={redirect || '/'} style={{ textDecoration: 'none' }}>
        <Brand>
          <BrandLogo src="/static/brand/logo.svg" alt="Purwadhika Logo" />
          <BrandDivider orientation="vertical" flexItem />
          <BrandTitle sx={{ typography: 'bodytext14' }}>{title}</BrandTitle>
        </Brand>
      </Link>
    );
  }

  return isWatchpage ? (
    <Link to={navLogoRedirect}>
      <Box sx={{ cursor: 'pointer' }}>
        <BrandLogo
          src="/static/brand/logopwdk-text.png"
          alt="Purwadhika Logo"
        />
      </Box>
    </Link>
  ) : (
    <Box sx={{ cursor: 'pointer' }} onClick={directToHome}>
      <BrandLogo src="/static/brand/logopwdk-text.png" alt="Purwadhika Logo" />
    </Box>
  );
};

export default NavBrand;
